module.exports = __webpack_public_path__ + "img/profile.eae8ea4f.svg";